import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "px-4 pt-4" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["innerHTML"]

import AButtonPrimary from '@/components/atoms/AButtonPrimary.vue'

	import type { ComputedRef } from 'vue'
	import { computed } from 'vue'
	import { useGeneral } from '@/hooks'

	
export default /*#__PURE__*/_defineComponent({
  props: {
		tabSelected: { type: String, default: '', required: true },
		filters: { type: Boolean, default: false },
		mainTable: { type: Boolean, default: false },
		loading: { type: Boolean, default: false },
		text: { type: String, default: '' }
	},
  emits: ['click'],
  setup(__props, { emit: $emit }) {

const $props = __props

	
	

	const { $t, $store, $router, $route, isDisplayXl } = useGeneral()

	const state = {
		no_data_img: require('@/assets/no_data.svg'),
		no_data_text: 'General_no_data_available',
		no_data_documents_html: 'General_no_data_available_documents_html'
	}

	const isDocumentation: ComputedRef<boolean> = computed(() => {
		return $props.mainTable && $props.tabSelected === 'documentation'
	})

	const containerHeight: ComputedRef<string> = computed(() => {
		const mainHeight = 'height: 80vh !important'
		const filtersHeight = 'height: 70vh !important'
		return $props.mainTable ? ($props.filters ? filtersHeight : mainHeight) : ''
	})

	const rows: ComputedRef<number> = computed(() => {
		const mainRows: number = isDisplayXl.value ? 9 : 5
		return $props.mainTable ? mainRows : 3
	})

	const tabSelectedElement: ComputedRef<string> = computed(() => $store.getters['roles/GET_TAB_ELEMENTS'][$props.tabSelected])
	const buttonText: ComputedRef<string> = computed(() =>
		$props.filters ? $t('Action_start_filtering') : $t('Action_create') + ' ' + $t(`General_${tabSelectedElement.value}`).toLowerCase()
	)

	function onClick() {
		$props.filters ? $emit('click') : createItem()
	}

	function createItem() {
		let tab = $route.params.tab
		let routeName = $route.name
		if ($props.filters) {
			tab = $props.tabSelected
			const mainModules = $store.getters['roles/GET_MAIN_MODULES']
			Object.keys(mainModules).forEach(key => {
				if (mainModules[key].includes(tab)) routeName = key
			})
		}
		routeName = routeName.replace('_edit', '').replace('_copy', '')
		routeName += '_edit'
		$router.push({ name: routeName, params: { tab, id: 'create' } })
	}

return (_ctx: any,_cache: any) => {
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return ($props.loading)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        ($props.mainTable)
          ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
              key: 0,
              type: "table-heading"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_skeleton_loader, { type: "table-thead" }),
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rows), (n) => {
            return (_openBlock(), _createBlock(_component_v_skeleton_loader, {
              key: n,
              type: "table-row-divider"
            }))
          }), 128))
        ])
      ], 64))
    : (_openBlock(), _createBlock(_component_v_row, {
        key: 1,
        align: "center",
        class: "fill-height",
        style: _normalizeStyle(_unref(containerHeight))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "text-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_img, {
                class: "mb-8",
                src: state.no_data_img,
                height: "100",
                contain: ""
              }, null, 8, ["src"]),
              (!!$props.text)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "text-h6 font-weight-bold",
                    textContent: _toDisplayString(_unref($t)($props.text))
                  }, null, 8, _hoisted_2))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "text-h6",
                    textContent: _toDisplayString(_unref($t)(state.no_data_text))
                  }, null, 8, _hoisted_3)),
              (_unref(isDocumentation))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "mt-4 text-subtitle-1 grey--text",
                    innerHTML: _unref($t)(state.no_data_documents_html)
                  }, null, 8, _hoisted_4))
                : _createCommentVNode("", true),
              (__props.mainTable)
                ? (_openBlock(), _createBlock(AButtonPrimary, {
                    key: 3,
                    class: "mt-2",
                    color: "tertiary",
                    text: _unref(buttonText),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (onClick()))
                  }, null, 8, ["text"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["style"]))
}
}

})